import {
    ChangeDetectionStrategy,
    Component,
    Input,
    Output,
    EventEmitter,
    OnChanges,
    SimpleChanges, HostListener, ElementRef, OnInit,
    ChangeDetectorRef,
    ViewChild // ۱. ایمپورت ViewChild اضافه شد
} from '@angular/core';
import {UserModel} from '../../models/user.model';
import {Workspace} from '../../models/work-space.model';
import {WorkSpaceDialogComponent} from '../work-space-dialog/work-space-dialog.component';
import {NbDialogRef, NbDialogService} from '@nebular/theme';
import {environment} from '../../../../../environments/environment';
import {SideBarMenu} from '../../models/side-bar-menu.model';
import {NbSidebarState} from '@nebular/theme/components/sidebar/sidebar.component';
import {ResponsiveMode} from '../../models/responsive-mode.type';
import { FakeBackdropComponent } from './fake-backdrop/fake-backdrop.component';
import { AuthFacade } from '../../../auth/facade/auth.facade';
import { VersionInfo } from '../../../auth/models/version.model';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ImportDashboardActivationModalComponent } from '../../../dashboard/components/dialogs/import-dashboard-activation-modal/import-dashboard-activation-modal.component';
import { ImportDashboardDatasourcesModalComponent } from '../../../dashboard/components/dialogs/import-dashboard-datasources-modal/import-dashboard-datasources-modal.component';

@Component({
    selector: 'tart-sidebar-menu',
    templateUrl: './sidebar-menu.component.html',
    styleUrls: ['./sidebar-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarMenuComponent implements OnChanges , OnInit {
    @Input() user: UserModel;
    @Input() workspaces: Partial<Workspace>[];
    @Input() selectedWorkspace: Partial<Workspace>;
    @Input() loading: boolean;
    @Input() logoPath: string;
    @Input() hasBackdrop: boolean;
    @Input() responsiveMode: ResponsiveMode;
    @Input() activeLink: string;
    @Input() activeTabId: string;
    @Output() titleChange = new EventEmitter<string>();
    @Output() workspaceIdChange = new EventEmitter<string>();
    @Output() selectedWorkspaceChange = new EventEmitter<Partial<Workspace>>();
    @Output() sideBarStateChange = new EventEmitter<NbSidebarState>();
    @Output() routeChange = new EventEmitter<string>();
    @Output() createDashboardEvent = new EventEmitter<string>();
    @Output() createDataSourceEvent = new EventEmitter<string>();
    
    allWorkspaceId = environment.allWorkspaceId;
    topSideBarMenu: Partial<SideBarMenu>[];
    bottomSideBarMenu: Partial<SideBarMenu>[];
    subSideBarBookmarkedMenu: Partial<SideBarMenu>[];
    subSideBarAllContentMenu: Partial<SideBarMenu>[];
    createAssetMode: boolean;
    createDashboardMode: boolean;
    selectWorkspaceMode: boolean;
    allWorkspaceMode: boolean;
    fakeBackdrop: NbDialogRef<FakeBackdropComponent>;
    versionInfo: VersionInfo;
    subscriptions: Subscription[] =[];
    selectedFile: File | null = null;
    selectedFileName: string | null = null;
    
    @ViewChild('fileImportInput') fileImportInput: ElementRef;

    constructor(
    private dialogService: NbDialogService,
    private elementRef: ElementRef,
    private router: Router,
    private authFacade: AuthFacade,
    private cdr: ChangeDetectorRef,)
    {}

    @HostListener('window:click', ['$event'])
    handleClick(event: Event) {
        this.createAssetMode = false;
        this.createDashboardMode = false;
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.selectWorkspaceMode = false;
        }
    }

    ngOnInit() {
      if (this.hasBackdrop) {
        this.fakeBackdrop = this.dialogService.open(FakeBackdropComponent,
          { closeOnBackdropClick: false });
        this.fakeBackdrop.onBackdropClick.subscribe(
          ()=>{
            this.compactedSideBar();
          },
        );
      }
      this.authFacade.loadVersionInfo();
      this.getVersionInfo();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ((changes['selectedWorkspace'] || changes['user'] || changes['responsiveMode'])
            && this.user && this.selectedWorkspace) {
            this.allWorkspaceMode = this.selectedWorkspace.workspaceId === this.allWorkspaceId;
            this.setSideBarValues(this.selectedWorkspace.workspaceId);
        }
        if (changes['activeLink'] || changes['activeTabId']) {
            this.cdr.detectChanges(); 
          }
          
    }
    
    getVersionInfo(): void {
        this.subscriptions.push(
          this.authFacade.getVersionInfo$().subscribe(
            (version: VersionInfo) => {
                this.versionInfo = version;
                this.cdr.detectChanges()
            },
            (error) => {
              console.error("Error fetching version info:", error);
            }
          )
        );
      }
      
      changeRoute(link: string): void {
        this.routeChange.emit(link);
        this.activeLink = link; 
        this.activeTabId = 'DashboardGroup'
        this.cdr.detectChanges(); 
    }

    changeRouteWithTab(link: string, tabId: string): void {
        this.routeChange.emit(link);
        this.activeTabId = tabId;
        this.activeLink = link;
        this.router.navigate([link], { queryParams: { selectedTab: tabId } });
        this.cdr.detectChanges();
      }
      
    changeTitle(title: string): void {
        this.titleChange.emit(title);
        if(this.responsiveMode === 'sm') {
            this.collapseSideBar();
        }
    }

    workspacesTrackBy(index: number, workspace: Partial<Workspace>): string {
        return workspace.workspaceId;
    }

    createWorkspace(): void {
        this.dialogService.open(WorkSpaceDialogComponent, {context: {type: 'home'}});
    }

    createDatasource(): void {
        this.createDataSourceEvent.emit();
    }

    collapseSideBar(): void {
      if (this.hasBackdrop) {
        this.fakeBackdrop.close();
      }
        this.sideBarStateChange.emit('collapsed');
    }

    compactedSideBar(): void {
      if (this.hasBackdrop) {
        this.fakeBackdrop.close();
      }
        this.sideBarStateChange.emit('compacted');
    }

    createDashboard(): void {
        this.createDashboardEvent.emit();
    }

    toggleSelectWorkspaceMode($event): void {
        $event.stopPropagation();
        this.selectWorkspaceMode = !this.selectWorkspaceMode;
    }

    selectWorkspace(selectedWorkspace: Partial<Workspace>): void {
        this.selectedWorkspaceChange.emit(selectedWorkspace);
        this.changeTitle('خانه');
    }

    toggleCreateAssetMode($event): void {
        if (!this.allWorkspaceMode) {
            this.createAssetMode = !this.createAssetMode;
            if(!this.createAssetMode){
              this.createDashboardMode = false;
            }
            $event.stopPropagation();
        }
    }
    
    toggleCreateDashboardMode($event): void {
            this.createDashboardMode = !this.createDashboardMode;
            $event.stopPropagation();
    }
    
    importDashboard(): void {
      if (this.fileImportInput) {
        this.fileImportInput.nativeElement.value = null;
        this.fileImportInput.nativeElement.click();
      }
    }   

    onFileSelected(event: Event): void {
      const input = event.target as HTMLInputElement;
    
      if (!input.files || input.files.length === 0) {
        return;
      }
    
      const file = input.files[0];
    
      this.dialogService.open(
        ImportDashboardActivationModalComponent,
        {
          closeOnBackdropClick: false,
          context: {
            title: 'بارگذاری داشبورد',
            workspaceId: this.selectedWorkspace.workspaceId,
            file: file,
          },
        }
      );
    
      input.value = '';
    }
    
    
    private setSideBarValues(workspaceId: string): void {
        this.topSideBarMenu = [
            {
                title: 'خانه',
                translateKey: 'NavigationSidebar.HOME',
                icon: 'home',
                link: `/home/${workspaceId}`,
                home: true,
                havingAccess: true,
            },
            {
                title: 'محتویات',
                translateKey: 'NavigationSidebar.EXPLORE',
                icon: 'folder',
                link: `/home/explore/${workspaceId}`,
                havingAccess: true,
            },
            {
                title: 'نشان‌شده',
                translateKey: 'NavigationSidebar.BOOKMARKED',
                icon: 'bookmark',
                link: `/home/bookmarked/${workspaceId}`,
                havingAccess: true,
            },
            {
                title: 'مدلسازی منابع‌داده',
                translateKey: 'NavigationSidebar.DATA MODELLING',
                icon: 'branches',
                link: `/dataModelling/${workspaceId}`,
                havingAccess: !this.allWorkspaceMode && this.selectedWorkspace.permissions.get('ViewDataSourceRelation').isChecked
                    && (this.responsiveMode === 'lg' || this.responsiveMode === 'xl'),
            },
            {
                title: 'مدیریت کاربران',
                translateKey: 'NavigationSidebar.USER MANAGEMENT',
                icon: 'userManagement',
                link: `/home/user-managment/${workspaceId}`,
                havingAccess: (this.user.isSuperAdmin || this.selectedWorkspace.permissions.get('UserManagement').isChecked)
                    && (this.responsiveMode === 'lg' || this.responsiveMode === 'xl'),
            },
        ];

        this.bottomSideBarMenu = [
            {
                title: 'تنظیمات',
                translateKey: 'NavigationSidebar.SETTINGS',
                icon: 'settings',
                link: `/home/setting/${workspaceId}`,
                havingAccess: this.user.isSuperAdmin
                    && (this.responsiveMode === 'lg' || this.responsiveMode === 'xl'),
            },
            {
                title: 'فضاهای کاری',
                translateKey: 'NavigationSidebar.WORKSPACES',
                icon: 'workspace',
                link: '/select-workspace',
                havingAccess: true,
            },
        ];
        
        this.subSideBarAllContentMenu = [
                {
                    title: 'گروه داشبوردی',
                    translateKey: 'NavigationSidebar.DASHBOARDGROUP',
                    icon: 'dashboardGroup',
                    link: `/home/explore/${workspaceId}`,
                    tabId: 'DashboardGroup', 
                    havingAccess: true,
                },
                {
                    title: 'داشبورد',
                    translateKey: 'NavigationSidebar.DASHBOARD',
                    icon: 'dashboard',
                    link: `/home/explore/${workspaceId}`,
                    tabId: 'Dashboard',
                    havingAccess: true,
                },
                {
                    title: 'منبع داده',
                    translateKey: 'NavigationSidebar.DATASOURCE',
                    icon: 'dataSource',
                    link: `/home/explore/${workspaceId}`,
                    tabId: 'DataSource',
                    havingAccess: true,
                }
            ];
        this.subSideBarBookmarkedMenu = [
            {
                title: 'گروه داشبوردی',
                translateKey: 'NavigationSidebar.DASHBOARDGROUP',
                icon: 'dashboardGroup',
                link: `/home/bookmarked/${workspaceId}`,
                tabId: 'DashboardGroup', 
                havingAccess: true,
            },
            {
                title: 'داشبورد',
                translateKey: 'NavigationSidebar.DASHBOARD',
                icon: 'dashboard',
                link: `/home/bookmarked/${workspaceId}`,
                tabId: 'Dashboard',
                havingAccess: true,
            },
           
        ]
    }
    
}
